const getPfasCategoriesColumnGroups = () => [
  {
    id: 'category',
    name: 'Category',
    hideInSelect: true,
  },
]

export { getPfasCategoriesColumnGroups }
